<template>
  <div>
    <el-breadcrumb separator-class="el-icon-arrow-right">
      <el-breadcrumb-item :to="{ path: '/' }">
        <app-i18n code="home.menu"></app-i18n>
      </el-breadcrumb-item>
      <el-breadcrumb-item :to="{ path: '/category' }">
        <app-i18n code="entities.category.menu"></app-i18n>
      </el-breadcrumb-item>
      <el-breadcrumb-item>
        <app-i18n code="entities.category.view.title"></app-i18n>
      </el-breadcrumb-item>
    </el-breadcrumb>

    <div class="app-content-page">
      <h1 class="app-content-title app-content-title--hidden">
        <app-i18n code="entities.category.view.title"></app-i18n>
      </h1>

      <div class="app-page-spinner" v-if="loading" v-loading="loading"></div>

      <app-category-view-toolbar v-if="record"></app-category-view-toolbar>

      <el-form
        :label-position="labelPosition"
        :label-width="labelWidthForm"
        @submit.prevent.native
        class="form"
        v-if="record"
      >
        <app-view-item-text :label="fields.id.label" :value="presenter(record, 'id')"></app-view-item-text>

        <app-view-item-text :label="fields.name.label" :value="presenter(record, 'name')"></app-view-item-text>

        <app-view-item-text :label="fields.label.label" :value="presenter(record, 'label')"></app-view-item-text>

        <app-view-item-text
          :label="fields.minBirthYear.label"
          :value="presenter(record, 'minBirthYear')"
        ></app-view-item-text>

        <app-view-item-text
          :label="fields.maxBirthYear.label"
          :value="presenter(record, 'maxBirthYear')"
        ></app-view-item-text>

        <app-view-item-text :label="fields.createdAt.label" :value="presenter(record, 'createdAt')"></app-view-item-text>

        <app-view-item-text :label="fields.updatedAt.label" :value="presenter(record, 'updatedAt')"></app-view-item-text>
      </el-form>
    </div>
  </div>
</template>

<script>
import { mapGetters, mapActions } from 'vuex';
import CategoryViewToolbar from '@modules/category/components/category-view-toolbar.vue';
import { CategoryModel } from '@modules/category/category-model';

export default {
  name: 'app-category-view-page',

  props: ['id'],

  components: {
    [CategoryViewToolbar.name]: CategoryViewToolbar,
  },

  computed: {
    ...mapGetters({
      labelPosition: 'layout/labelPosition',
      labelWidthForm: 'layout/labelWidthForm',
      record: 'category/view/record',
      loading: 'category/view/loading',
      dateFormat: 'auth/manage/dateFormat',
      populateDate: 'auth/manage/populateDate',
    }),

    fields() {
      const { dateFormat, populateDate } = this;
      return new CategoryModel({
        dateFormat,
        populateDate,
      }).fields();
    },
  },

  async created() {
    await this.doFind(this.id);
  },

  methods: {
    ...mapActions({
      doFind: 'category/view/doFind',
    }),

    presenter(record, fieldName) {
      const { dateFormat, populateDate } = this;
      return new CategoryModel({
        dateFormat,
        populateDate,
      }).presenter(record, fieldName);
    },
  },
};
</script>
